import "./styles/foundation.css";
import "./styles/shared.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App, { preloadRoute } from "./App";
import Footer from "./component/footer";
import { AuthProvider } from "./component/AuthContext";
import "./a11y/a11y.css";

const footerRootEl = document.getElementById("react-footer-root");
const rootEl = document.getElementById("root");

// Static Blog Pages: Render ONLY Footer wrapped in BrowserRouter
if (footerRootEl) {
  ReactDOM.createRoot(footerRootEl).render(
    <React.StrictMode>
      <BrowserRouter>
        <Footer />
      </BrowserRouter>
    </React.StrictMode>
  );
} 
// Main SPA Website
else if (rootEl) {
  const render = () =>
    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        <AuthProvider>
          <App />
        </AuthProvider>
      </React.StrictMode>
    );
  // A prerendered page (react-snap) already shows its content: render once that page's code is in, so the
  // content is never swapped for the loading placeholder first. An empty page renders at once (the placeholder
  // keeps the navbar and footer in place while the page's code downloads).
  if (rootEl.firstElementChild) preloadRoute(window.location.pathname).then(render, render);
  else render();
}